import inViewport from '@resources/js/helpers/inViewport'

const initToggleFilters = async () => {
    const toggleTriggerElement = document.querySelector('.js-trigger-toggle')

    if (!toggleTriggerElement) return

    const { default: Toggle } = await import('@resources/js/ui/Toggle')
    new Toggle(toggleTriggerElement, { target: '.js-toggle-filters' })
}

inViewport('.js-toggle-filters', initToggleFilters)
